import styled from 'styled-components';
import { Box } from 'reflexbox';

export const ScrollY = styled(Box)`
  overflow-y: auto;
`;
